import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import axios from "axios";
import LoaderHomePd from "../components/loaderHomePd";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";


const Artists = () => {

        const [artistListLegend, setArtistListLegend] = useState([]);
        const [artistListEstablished, setArtistListEstablished] = useState([]);
        const [artistListUpcoming, setArtistListUpcoming] = useState([]);
        const navigate = useNavigate();
        const [loading, setLoading] = useState(true);

        const getArtistListAll = async () => {

            try {
                setLoading(true);
                const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
                await delay;
    
                const response1 = await axios.get(`https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtistListByArtistType?artistTypeid=3`) // artistType id 3 for Legend Artist
                setArtistListLegend(response1.data);

                const response2 = await axios.get(`https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtistListByArtistType?artistTypeid=1`) // artistType id 2 for Established Artist
                setArtistListEstablished(response2.data);

                const response3 = await axios.get(`https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtistListByArtistType?artistTypeid=2`) // artistType id 2 for Upcoming Artist
                setArtistListUpcoming(response3.data);
            }
            catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
       

        const columnsLegend = [
                {
                    cell: (row) => {
                        
                        return (
                            <div className="pd_item" key={row.artist_id}>
                                <div className="img_box">
                                    <img src={`../../../images/products/thumbnail/${row.image}`} className="pd_img" alt="" />
                                    
                                    <span className="size"><b>({row.artworkCount})</b> Artworks</span>
                                </div>
                                <div className="pd_content">
                                    <span className="pd_title" style={{ textAlign: "center", fontWeight: "bold", display: "block" }}>
                                        <span className="btn_artist1" onClick={() => handleArtist(row.artist_id, row.artistName)}
                                            style={{ cursor: "pointer", color: "#000", textDecoration: "none" }}>
                                            {row.artistName}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        );
                    }
                },
            ];
            const columnsEstablished = [
                {
                    cell: (row) => {
                        
                        return (
                            <div className="pd_item" key={row.artist_id}>
                                <div className="img_box">
                                    <img src={`../../../images/products/thumbnail/${row.image}`} className="pd_img" alt="" />
                                    
                                    <span className="size"><b>({row.artworkCount})</b> Artworks</span>
                                </div>
                                <div className="pd_content">
                                    <span className="pd_title" style={{ textAlign: "center", fontWeight: "bold", display: "block" }}>
                                        <span className="btn_artist1" onClick={() => handleArtist(row.artist_id, row.artistName)}
                                            style={{ cursor: "pointer", color: "#000", textDecoration: "none" }}>
                                            {row.artistName}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        );
                    }
                },
            ];
            const columnsUpcoming = [
                {
                    cell: (row) => {
                        
                        return (
                            <div className="pd_item" key={row.artist_id}>
                                <div className="img_box">
                                    <img src={`../../../images/products/thumbnail/${row.image}`} className="pd_img" alt="" />
                                    
                                    <span className="size"><b>({row.artworkCount})</b> Artworks</span>
                                </div>
                                <div className="pd_content">
                                    <span className="pd_title" style={{ textAlign: "center", fontWeight: "bold", display: "block" }}>
                                        <span className="btn_artist1" onClick={() => handleArtist(row.artist_id, row.artistName)}
                                            style={{ cursor: "pointer", color: "#000", textDecoration: "none" }}>
                                            {row.artistName}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        );
                    }
                },
            ];
        
            const paginationComponentOptions = {
                noRowsPerPage: true
            };
        
            useEffect(() => {
                getArtistListAll();
            }, []);

            const handleArtist = (artistId, artistName) => {
                const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
                navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId}});
                window.scrollTo({
                    top: 0,
                    behavior: "instant"
                });
            };

    return (
        <>
            <Header />
            <div style={{ marginTop: '150px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <h2 className="sec_title">INDIGALLERIA'S FEATURED ARTISTS WITH THEIR LATEST ARTWORK</h2>
                        
                            <span className="details">
                            <p>Immerse yourself in the vibrant world of Indian art! At IndiGalleria, we celebrate the exceptional talent of contemporary Indian artists. Our featured collection showcases a diverse range of styles, from captivating colors to calming compositions.</p>
                            <p><b>Here's what awaits you:</b></p>
                            <p><b>Unique artistic voices: </b>Explore a variety of styles and techniques, each reflecting the artist's distinct perspective.</p>
                            <p><b>The mastery of Indian art: </b>Discover breathtaking brushstrokes and captivating color palettes that are a hallmark of Indian visual art.</p>
                            <p><b>Latest masterpieces: </b>Be among the first to own these stunning new creations by renowned and emerging Indian artists.</p>
                            <p><b>IndiGalleria is your gateway to bring a piece of India's rich artistic heritage to your home.</b></p>

                            </span>

                        </div>
                        

                        <div className="col-md-12 pd-list">
                        <h2 className="sec_title">LEGEND ARTISTS</h2>
                            {
                                loading ? (<LoaderHomePd />
                                ) : (
                                    <DataTable
                                        columns={columnsLegend}
                                        data={artistListLegend}
                                        pagination
                                        noTableHead
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationPerPage={[20]}
                                    />
                                )}
                        </div>

                        <div className="col-md-12 pd-list">
                        <h2 className="sec_title">ESTABLISHED ARTISTS</h2>
                            {
                                loading ? (<LoaderHomePd />
                                ) : (
                                    <DataTable
                                        columns={columnsEstablished}
                                        data={artistListEstablished}
                                        pagination
                                        noTableHead
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationPerPage={[20]}
                                    />
                                )}
                        </div>

                        <div className="col-md-12 pd-list">
                        <h2 className="sec_title">UPCOMING ARTISTS</h2>
                            {
                                loading ? (<LoaderHomePd />
                                ) : (
                                    <DataTable
                                        columns={columnsUpcoming}
                                        data={artistListUpcoming}
                                        pagination
                                        noTableHead
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationPerPage={[20]}
                                    />
                                )}
                        </div>

                    </div>

                </div>
            </div>
            <Footer />
        </>
    )
};
export default Artists;